import React, { useEffect, useState } from "react";
import Accordion from "../../component/global/accordion";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import CircleEffect from "../../component/global/circleEffect";
import '../../index.css';
import ViewConfig from "../../config/viewConfig";
import { setFAQChosenData } from "../../redux/actions/faqActions";
import { setLanguage } from "../../redux/actions/language";
import { useParams } from "react-router-dom";

const FAQ = ({ }) => {
    const { lang } = useSelector((state) => state.globalReducer);
    const dispatch = useDispatch();
    const { choosenData } = useSelector((state) => state.faqReducer);
    const mobileView = ViewConfig();
    const [selectedItem, setSelectedItem] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    useEffect(() => {
        dispatch(setFAQChosenData(faqData[0]))
        setSelectedItem(faqData[0]?.title)

    }, [])

    const { language } = useParams();

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const faqData = [
        {
            title: Lang(lang, 'faq_title1'),
            data: [
                {
                    title: Lang(lang, 'faq_q1'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a1')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q2'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a2')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q3'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a3')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q4'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a4')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q5'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a5')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q6'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a6')}
                        </div>)
                }
            ]

        },
        {
            title: Lang(lang, 'faq_title2'),
            data: [
                {
                    title: Lang(lang, 'faq_q7'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a7')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q8'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a8')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q9'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a9')}
                        </div>)
                }
            ]
        },
        {
            title: Lang(lang, 'faq_title3'),
            data: [
                {
                    title: Lang(lang, 'faq_q13'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a13')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q11'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a11')}
                        </div>)
                },
                {
                    title: Lang(lang, 'faq_q12'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a12')}
                        </div>)
                }
            ]
        },
        {
            title: Lang(lang, 'faq_title4'),
            data: [
                {
                    title: Lang(lang, 'faq_q13'),
                    content: (
                        <div className="pr-5 pl-10 md:pl-12">
                            {Lang(lang, 'faq_a13')}
                        </div>)
                }
            ]
        },
    ];


    return (
        <div className="pb-20">
            <div className="pt-8">
                <p className={'text-[#48494B] font-normal text-[32px] md:text-[72px] leading-tight text-center'}>
                    {<>
                        {Lang(lang, 'still')} <CircleEffect
                            setClass={'text-[#EA2427] font-semibold'}
                            setClassDoodle={'-bottom-16 md:-bottom-15 h-[145px] md:h-[140px] w-full left-[-2px] md:left-[-1px]'}
                            text={`${Lang(lang, 'curious')}?`}
                            setColor="#034694"
                            type="line"
                        />
                    </>
                    }
                </p>
            </div>


            <div className="pt-2 md:pt-10 flex flex-col md:flex-row w-[80%] md:w-[72%] max-w-[1180px] mx-auto ">
                {!mobileView ? (choosenData && (
                    <div className="w-[25%] mr-[5%]">
                        {faqData.map((val, idx) => (
                            <a href="" onClick={(e) => {
                                e.preventDefault();
                                dispatch(setFAQChosenData(val))
                            }}>
                                <div key={idx} className='faq-sidebar py-3 px-3' >
                                    <p className={(choosenData.title === val?.title ? 'text-[17px] text-bold text-[#034694]' : 'text-[17px] text-medium')} >{val.title}</p>
                                </div>
                            </a>
                        ))}
                    </div>)) : <div className="flex flex-col mt-8 mb-6" style={{ position: 'relative' }} >
                    <div onClick={() => {
                        if (isDropdownOpen === true) {
                            setIsDropdownOpen(false)
                        } else {
                            setIsDropdownOpen(true);
                        }
                    }} className="rounded-full border border-[#a1a4a8] flex justify-between items-center py-2 px-4 min-w-[260px] md:min-w-[250px]"
                        style={isDropdownOpen === true ? { backgroundColor: '#034694' } : {}}>
                        <p className="text-sm md:text-base" style={isDropdownOpen === true ? { color: 'white' } : {}}>{selectedItem}</p>
                        <svg data-accordion-icon className={isDropdownOpen !== true ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6" style={isDropdownOpen === true ? { color: 'white' } : {}}>
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
                        </svg>
                    </div>
                    {isDropdownOpen && <div
                        style={{
                            position: 'absolute',
                            top: '100%',
                            width: '100%',
                            right: 0,
                            marginTop: '8px',
                            borderRadius: '12px',
                            padding: '10px',
                            zIndex: 999,
                        }}
                        className="glass-card-dropdown"
                    >
                        {faqData.map((option) => (
                            <label
                                key={option.title}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px',
                                    cursor: 'pointer',
                                    color:'#000'
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={choosenData?.title === option.title}
                                    onChange={() => {
                                        dispatch(setFAQChosenData(option))
                                        setIsDropdownOpen(false)
                                        setSelectedItem(option.title)
                                    }}
                                    style={{ marginRight: '8px' }}
                                />
                                {option.title}
                            </label>
                        ))}
                    </div>}
                </div>}
                <div className=" md:w-[70%] max-w-[1180px] mx-auto">
                    {choosenData.data && <Accordion key={choosenData.title} items={choosenData.data} isWithID={true} />}
                </div>

            </div>
        </div>)
}

export default FAQ